export let gallary = [
    {
        src: "images/drafting/architecture.png",
        title: "As Builds <br> Preparation"
    },
    {
        src: "images/drafting/redline_markup.png",
        title: "Redline Markup <br> Incorporation"
    }, {
        src: "images/drafting/rebar_shop.png",
        title: "Rebar <br> Shop drawings"
    }, {
        src: "images/drafting/concrete.png",
        title: "Concrete & <br> other elements "
    }, {
        src: "images/drafting/shop_drawings.png",
        title: "Shop <br> Drawings"
    }, {
        src: "images/drafting/structural_steel.png",
        title: "Structural Steel <br> Fabrication Drawings"
    }, {
        src: "images/drafting/road_layouts.png",
        title: "Road <br> Layouts"
    }, {
        src: "images/drafting/removals.png",
        title: "Removals"
    }
]
export let estimate_gallery  = [
    {
        src: "images/estimate_gallery/design.png",
        title:"Design or <br> Architecture "
    },
    {
        src: "images/estimate_gallery/change_order.png",
        title:"Change Order <br> Estimates "
    },
    {
        src: "images/estimate_gallery/plumbing.png",
        title:"Plumbing or <br> Estimation "
    },
    {
        src: "images/estimate_gallery/budget.png",
        title:"Budget or <br> Estimates "
    },
    {
        src: "images/estimate_gallery/design_estimate.png",
        title:"Design or <br> Estimates "
    },
    {
        src: "images/estimate_gallery/bid.png",
        title:"Bid <br> Estimates"
    },
    {
        src: "images/estimate_gallery/framing.png",
        title:"Framing <br> Estimation"
    },
    {
        src: "images/estimate_gallery/roofing.png",
        title:"Roofing <br> Estimation "
    },
    {
        src: "images/estimate_gallery/home.png",
        title:"Structural Items <br> Estimation "
    },
    {
        src: "images/estimate_gallery/takeoff.png",
        title:"Rebar Scheduling <br> and Takeoffs "
    }, 
]


export let estimate_gallery_mbl  = [
    {
        src: "images/estimate_gallery/design.png",
        title:"Design <br> Architecture "
    },
    {
        src: "images/estimate_gallery/change_order.png",
        title:"Change Order <br> Estimates "
    },
     
    {
        src: "images/estimate_gallery/bid.png",
        title:"Bid <br> Estimates"
    },
    {
        src: "images/estimate_gallery/framing.png",
        title:"Framing <br> Estimation"
    },

    {
        src: "images/estimate_gallery/plumbing.png",
        title:"Plumbing <br> Estimation "
    },
    {
        src: "images/estimate_gallery/budget.png",
        title:"Budget <br> Estimates "
    },

    {
        src: "images/estimate_gallery/roofing.png",
        title:"Roofing <br> Estimation "
    },
    {
        src: "images/estimate_gallery/home.png",
        title:"Structural Items <br> Estimation "
    },
    {
        src: "images/estimate_gallery/design_estimate.png",
        title:"Design <br> Estimates "
    },
    
    
    {
        src: "images/estimate_gallery/takeoff.png",
        title:"Rebar Scheduling <br> and Takeoffs "
    }, 
]






export let gallary_mobile = [
    {
        src: "images/drafting/mobile/architecture.png",
        title: "As Builds <br> Preparation",
        bottom_value: "-2.9vw",
    },
    {
        src: "images/drafting/mobile/redline_markup.png",
        title: "Redline <br> Markup <br> Incorporation",
        bottom_value: "3.5vw",
    }, {
        src: "images/drafting/mobile/rebar_shop.png",
        title: "Rebar <br> Shop  <br> Drawings",
        bottom_value: "3.5vw",
    }, {
        src: "images/drafting/mobile/concrete.png",
        title: "Concrete & Other <br> Elements ",
        bottom_value: "-2.9vw",
    }, {
        src: "images/drafting/mobile/shop_drawings.png",
        title: "Shop <br> Drawings",
        bottom_value: "-2.9vw",
    }, {
        src: "images/drafting/mobile/structural_steel.png",
        title: "Structural Steel <br> Fabrication <br> Drawings",
        bottom_value: "3.5vw",
    }, {
        src: "images/drafting/mobile/road_layouts.png",
        title: "Road <br> Layouts",
        bottom_value: "-2.9vw",
    }, {
        src: "images/drafting/mobile/removals.png",
        title: "Removals",
        bottom_value: "-2.9vw",
    }
]